import "@hotwired/turbo-rails"
import "./controllers/application"

import "./blurhash"

// Polyfill popover on any browsers that lack support
import "@oddbird/popover-polyfill"

import { TurboConfirm } from "@rolemodel/turbo-confirm"
import TC from "@rolemodel/turbo-confirm"

const ICON_SLOT_SELECTOR = "#confirm-icon"

const turboConfirmSettings = {
  dialogSelector: "#turbo-confirm",
  contentSlots: {
    body: {
      contentAttribute: "confirm-description",
      slotSelector: "#confirm-body",
    },
    acceptText: {
      contentAttribute: "confirm-button",
      slotSelector: "#confirm-accept-text",
    },
    confirmIcon: {
      contentAttribute: "confirm-icon",
      slotSelector: ICON_SLOT_SELECTOR,
    },
    cancelText: {
      contentAttribute: "confirm-cancel",
      slotSelector: "#confirm-cancel-text",
    },
  },
  // The turbo-confirm library skips slot updates when content is null, so an empty data-confirm-icon
  // would never clear the default icon. We handle it here instead, after the library has
  // already stored the dialog's initial content (so the restore cycle is unaffected).
  showConfirmCallback: (element) => {
    const trigger = document.activeElement?.closest("[data-confirm-icon]")
    if (trigger?.getAttribute("data-confirm-icon") === "") {
      const iconSlot = element.querySelector(ICON_SLOT_SELECTOR)
      if (iconSlot) iconSlot.innerHTML = ""
    }
    element.showModal?.()
  },
}

TC.start(turboConfirmSettings)
window.turboConfirm = new TurboConfirm(turboConfirmSettings)
